<template>
  <div class="invite-root" :style="cssVars()">
    <div class="custom-nav-block" :class="[scrollTop ? 'nav-scrolling' : 'nav-default']" :style="{ 'padding-top': `${topBarHeight}px` }">
      <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <!-- Agent Center -->
          <span class="tit-left">{{ $t('lang.Invite.k006') }}</span>
        </template>
        <template v-if="baseInfo && baseInfo.avatar" #right>
          <div class="target-avatar" @click="handleToAgentProfile">
            <img :src="baseInfo.avatar | imgPath" alt="" style="object-fit: cover" />
          </div>
        </template>
      </van-nav-bar>
    </div>

    <div class="invite-hero">
      <div class="hero-bg" :style="`padding-top: ${topBarHeight + 46}px`">
        <!-- prettier-ignore -->
        <div v-if="pageLoading || baseInfo" class="earn-tips" :class="{ 'is-placeholder': pageLoading }">
          <!-- 活动进行 -->
          <MyPLabel
            v-if="baseInfo && baseInfo.subAgentActMaxReward && baseInfo.subAgentActTimeStart && baseInfo.subAgentActTimeEnd"
            class="earn-line"
            :str="$t('lang.Invite.k015')"
            :numsOption="earnLineNumsOption"
            :customClass="{ bean: 'sub-agent-bean' }"
          />
          <!-- 活动结束 -->
          <MyPLabel 
            v-else
            class="earn-line"
            :str="$t('lang.Invite.k016')"
            :numsOption="earnLineNumsOption"
          />
        </div>

        <div v-if="pageLoading || baseInfo" class="invite-code" :class="{ 'is-placeholder': pageLoading }" @click="handleCopyCode">
          <span class="code-label">{{ $t('lang.Invite.k009') }} :</span>
          <span class="code-value">{{ pageLoading ? '------' : baseInfo.inviteCode || '' }}</span>
          <img v-if="!pageLoading" class="copy-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/copy.webp" alt="" />
        </div>

        <div class="action-btns" :class="{ 'is-disabled': pageLoading }">
          <div class="btn-invite-hostess" @click="handleInvite">{{ $t('lang.Invite.k141') }}</div>
          <div class="btn-invite-sub" @click="handleInviteSubAgent">{{ $t('lang.Invite.k101') }}</div>
        </div>
      </div>

      <div class="side-actions">
        <div class="side-btn" @click="handleToRules">
          <img src="@/assets/packageAssets/views/P2_Page/Invite/default/question1.webp" alt="" />
          <span>{{ $t('lang.BaseCommon.k005') }}</span>
        </div>
        <div class="side-btn" @click="handleToPolicy">
          <img src="@/assets/packageAssets/views/P2_Page/Invite/default/board.webp" alt="" />
          <span>{{ $t('lang.Invite.k010') }}</span>
        </div>
      </div>

      <div v-if="showBindUpAgent" class="bind-up-agent" @click="handleBindUpAgent">
        <span class="bind-up-agent-title">{{ $t('lang.Invite.k102') }}</span>
        <div class="bind-up-agent-right">
          <span class="bind-up-agent-time" :class="{ 'is-urgent': bindUpAgentCountdownUrgent }">{{ bindUpAgentCountdownText }}</span>
          <img class="bind-up-agent-arrow ar-arrow" src="@/assets/packageAssets/common/arrow11.webp" alt="" />
        </div>
      </div>
    </div>

    <!-- tab switch -->
    <div ref="switchTabRef" class="switch-tab" :style="switchTabStickyStyle">
      <div class="switch-tab-bg"></div>
      <div class="switch-tab-inner">
        <div class="tab" :class="{ 'active-tab': tabIndex == tabEnmu.dashboard }" @click.stop="handleSwitchTab(tabEnmu.dashboard)">
          <span class="tab-inner">{{ $t('lang.Invite.k057') }}</span>
        </div>
        <div class="tab" :class="{ 'active-tab': tabIndex == tabEnmu.hostes }" @click.stop="handleSwitchTab(tabEnmu.hostes)">
          <span class="tab-inner">{{ $t('lang.Invite.k008') }}</span>
        </div>
        <div class="tab" :class="{ 'active-tab': tabIndex == tabEnmu.subAgent }" @click.stop="handleSwitchTab(tabEnmu.subAgent)">
          <span class="tab-inner">{{ $t('lang.Invite.k089') }}</span>
        </div>
      </div>
    </div>
    <!-- tab pane -->
    <div class="tab-pane-wrap" :style="tabPaneWrapStyle">
      <InvitePageSkeleton v-if="pageLoading" />
      <template v-else-if="baseInfo">
        <DashboardTab v-if="tabIndex === tabEnmu.dashboard" :info="baseInfo" />
        <HostessTab v-if="tabIndex === tabEnmu.hostes" :info="baseInfo" />
        <SubAgentTab v-if="tabIndex === tabEnmu.subAgent" :info="baseInfo" />
      </template>
    </div>

    <BindUplineAgentDialog :show="showBindDialog" :loading="bindSubmitting" @close="closeBindDialog" @confirm="handleBindConfirm" />
    <BindAgentMessageDialog
      :show="showBindMessageDialog"
      :message="bindMessageText"
      :mode="bindDialogMode"
      :nickname="bindConfirmNickname"
      @confirm="handleBindMessageConfirm"
      @cancel="handleBindMessageCancel"
      @close="handleBindMessageCancel"
    />
  </div>
</template>

<script>
import { apiFetchInviteV2HomePage, agentPageTypeApi } from '@/api/invite'
import { checkInvitedAgentBeforeBind, submitAgentBind } from './utils/agent-bind.js'
import { tabEnmu } from './utils/enum'
import { pageCssVars } from './z-style-cfg.js'
import { remainSec, fmtText, isUrgent } from './utils/bind-countdown.js'

import DashboardTab from './components/DashboardTab.vue'
import HostessTab from './components/Hostess/HostessTab.vue'
import SubAgentTab from './components/SubAgent/SubAgentTab.vue'
import InvitePageSkeleton from './InvitePageSkeleton/index.vue'
import BindUplineAgentDialog from './components/BindUplineAgentDialog.vue'
import BindAgentMessageDialog from './components/BindAgentMessageDialog.vue'
import eventBus from '@/utils/eventbus.js'
import scrollMixin from '@/hooks/scroll.mixin.js'

export default {
  mixins: [scrollMixin, pageCssVars],
  components: {
    DashboardTab,
    HostessTab,
    SubAgentTab,
    BindUplineAgentDialog,
    BindAgentMessageDialog,
    InvitePageSkeleton,
  },
  data() {
    return {
      tabEnmu: tabEnmu,
      tabIndex: tabEnmu.dashboard,
      pageLoading: true,
      baseInfo: null,
      bindUpAgentRemainingSeconds: 0,
      bindUpAgentCountdownTimer: null,
      nativeScroll: null,
      showBindDialog: false,
      showBindMessageDialog: false,
      bindMessageText: '',
      bindDialogMode: 'error',
      bindConfirmNickname: '',
      pendingBindCode: '',
      bindSubmitting: false,
    }
  },
  computed: {
    switchTabStickyStyle() {
      return {
        top: `${this.topBarHeight + 46}px`,
      }
    },
    tabPaneWrapStyle() {
      const reserved = this.topBarHeight + 46 + 52 + 20
      return {
        minHeight: `calc(100vh - ${reserved}px)`,
      }
    },
    showBindUpAgent() {
      return this.baseInfo && this.baseInfo.subAgentBindState === 0 && this.bindUpAgentRemainingSeconds > 0
    },
    bindUpAgentCountdownText() {
      return fmtText(this.bindUpAgentRemainingSeconds || 0)
    },
    bindUpAgentCountdownUrgent() {
      return isUrgent(this.bindUpAgentRemainingSeconds || 0)
    },
    earnLineNumsOption() {
      if (this.pageLoading || !this.baseInfo || !this.baseInfo?.maxShareRate || !this.baseInfo?.subAgentActMaxReward) {
        return [
          { value: '--', class: 'earn-percent' },
          { value: '--', class: 'earn-bonus' },
        ]
      }

      return [
        {
          value: this.baseInfo.maxShareRate,
          class: 'earn-percent',
        },
        {
          value: this.baseInfo.subAgentActMaxReward / 1000,
          class: 'earn-bonus',
        },
      ]
    },
  },
  methods: {
    // 规则页面
    handleToRules() {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'entrance', AValue: 'rules' })
      } catch (err) {
        console.log('try catch', err)
      }
      this.$router.push({ path: '/invite-rules' })
    },
    // 协议页面
    handleToPolicy() {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'entrance', AValue: 'policy' })
      } catch (err) {
        console.log('try catch', err)
      }
      // 动态的政策页面
      this.$router.push({ path: '/invite-dypolicy', query: { identity: 0, language: this.$i18n.locale } })
    },
    handleCopyCode() {
      if (this.pageLoading || !this.baseInfo) return
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'button', AValue: 'copy' })
      } catch (err) {
        console.log('try catch', err)
      }

      this.handleCopy(this.baseInfo.inviteCode || '', this.$t('lang.BaseCommon.k071'))
    },
    // AgentProfile页面
    handleToAgentProfile() {
      if (this.baseInfo && this.baseInfo.ifShowContactPage) {
        this.$router.push({ path: '/agent-profile', query: { scene: '0' } })
      }
      //
      else {
        this.$client.showToast(this.$t('lang.Invite.k058'))
      }
    },
    handleInviteSubAgent() {
      this.shareInviteDownload('/download_agent/index.html', 'InviteSubAgent')
    },
    handleBindUpAgent() {
      this.showBindDialog = true
    },
    closeBindDialog() {
      this.showBindDialog = false
    },
    closeBindMessageDialog() {
      this.showBindMessageDialog = false
      this.bindMessageText = ''
      this.bindDialogMode = 'error'
      this.bindConfirmNickname = ''
    },
    handleBindMessageConfirm() {
      if (this.bindDialogMode === 'confirm') {
        this.showBindMessageDialog = false
        this.bindDialogMode = 'error'
        this.doSubmitAgentBind(this.pendingBindCode)
        return
      }
      this.closeBindMessageDialog()
    },
    handleBindMessageCancel() {
      if (this.bindDialogMode === 'confirm') {
        this.bindSubmitting = false
        this.pendingBindCode = ''
      }
      this.closeBindMessageDialog()
    },
    doSubmitAgentBind(code) {
      const inviteCode = (code || '').trim()
      if (!inviteCode) {
        this.bindSubmitting = false
        return
      }
      // 实际绑定api接口
      submitAgentBind(inviteCode)
        .then((resData) => {
          if (resData) {
            // 绑定成功
            if (!resData.error) {
              const tempTip = this.handleOneText(this.$t('lang.Invite.k144'), '{n0}', resData.nickName || '') || this.$t('lang.BaseCommon.k105')
              this.$client.showToast(tempTip)
              this.baseInfo.subAgentBindState = 1
            }
            // 绑定失败
            else {
              this.$client.showToast(resData.error.description || this.$t('lang.BaseCommon.k009'))
            }
          }
        })
        .catch(() => {
          this.$client.showToast(this.$t('lang.BaseCommon.k009'))
        })
        .finally(() => {
          this.bindSubmitting = false
          this.pendingBindCode = ''
        })
    },
    handleBindConfirm(inviteCode) {
      if (this.bindSubmitting) {
        return
      }
      this.bindSubmitting = true

      this.pendingBindCode = inviteCode
      checkInvitedAgentBeforeBind(inviteCode)
        .then(({ needConfirm, agentInfo }) => {
          // 需要确认-提示消息
          if (needConfirm) {
            this.closeBindDialog()
            this.bindDialogMode = 'confirm'
            this.bindConfirmNickname = (agentInfo && agentInfo.nickname) || ''
            this.showBindMessageDialog = true
            return
          }
          // 不需要确认
          else {
            this.doSubmitAgentBind(inviteCode)
          }
        })
        .catch(() => {
          this.bindSubmitting = false
          this.pendingBindCode = ''
        })
    },
    handleInvite() {
      this.shareInviteDownload('/download/index.html', 'Invite')
    },
    getShareTitle() {
      const shareTitleMap = {
        echo: 'Echo - Live video chat',
        joychat: 'Joychat - Live video chat',
        joyu: 'Joyu - Live video chat',
        kiko: 'Kiko - Live video chat',
        vava: 'Vava - Live video chat',
        vibeo: 'Vibeo - Live video chat',
        whonow: 'WhoNow - Live video chat',
      }

      return shareTitleMap[this.packageName] || shareTitleMap.vava
    },
    shareInviteDownload(downloadPath, trackValue) {
      if (this.pageLoading || !this.baseInfo || !this.baseInfo.inviteCode) return
      const lang = this.$client.getAppInfoLang()
      const address = this.getMatchAddress()

      const appName = this.getAppName() || 'com.client.goparty'

      const enc = encodeURIComponent
      const query = `lang=${enc(lang)}&code=${enc(this.baseInfo.inviteCode || '')}&appName=${enc(appName)}`
      const url = `https://${address}${downloadPath}?${query}`

      const des = this.$t('lang.Invite.k002') || "I've made 10000 beans (worth $10) here by answering calls, join me now!"

      this.$client.copyLink(`${des} # ${url}`, this.$t('lang.BaseCommon.k071'))

      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'button', AValue: trackValue })
      } catch (err) {
        console.log('try catch', err)
      }

      try {
        const params = {
          title: this.getShareTitle(),
          description: des,
          url: url,
        }
        shareIntent.postMessage(JSON.stringify(params))
      } catch (err) {
        console.log('try catch', err)
      }
    },
    handleSwitchTab(index) {
      if (this.tabIndex === index) return
      this.tabIndex = index
      if (this.nativeScroll) {
        this.nativeScroll.lockLoad = false
      }
      this.$nextTick(() => {
        this.scrollToTabAnchor()
      })
    },
    scrollToTabAnchor() {
      const switchTab = this.$refs.switchTabRef
      if (!switchTab) return

      const stickyTop = this.topBarHeight + 46
      const tabAnchorScrollTop = switchTab.offsetTop - stickyTop
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0

      if (currentScrollTop <= tabAnchorScrollTop) return

      const target = Math.max(0, tabAnchorScrollTop)
      window.scrollTo(0, target)
      document.body.scrollTop = target
      document.documentElement.scrollTop = target
    },
    updateBindUpAgentCountdown() {
      const deadTime = this.baseInfo && this.baseInfo.becomeSubAgentDeadTime
      this.bindUpAgentRemainingSeconds = remainSec(deadTime)
    },
    startBindUpAgentCountdown() {
      this.stopBindUpAgentCountdown()
      this.updateBindUpAgentCountdown()
      if (!this.showBindUpAgent) return

      this.bindUpAgentCountdownTimer = setInterval(() => {
        if (this.bindUpAgentRemainingSeconds <= 0) {
          this.stopBindUpAgentCountdown()
          return
        }
        this.bindUpAgentRemainingSeconds--
      }, 1000)
    },
    stopBindUpAgentCountdown() {
      if (this.bindUpAgentCountdownTimer) {
        clearInterval(this.bindUpAgentCountdownTimer)
        this.bindUpAgentCountdownTimer = null
      }
    },
    // 页面数据相关
    getBaseInfo(options = {}) {
      const { silent = false } = options
      if (!silent) {
        this.pageLoading = true
      }
      return apiFetchInviteV2HomePage()
        .then((res) => {
          this.baseInfo = res || null
          this.updateBindUpAgentCountdown()
          this.startBindUpAgentCountdown()

          if (this.baseInfo && typeof this.baseInfo.inviteCount !== 'undefined') {
            try {
              window.ta && window.ta.track('agent_center', { Action: 'Display', AValue: this.baseInfo.inviteCount > 0 ? 'binded' : 'unbind' })
            } catch (err) {
              console.log('try catch', err)
            }
          }
        })
        .finally(() => {
          this.pageLoading = false
        })
    },
    initNativeScroll(event) {
      const clientH = document.documentElement.clientHeight
      const scrollH = document.body.scrollHeight
      const scrollT = event.target.scrollTop
      const distance = 400

      // 触底
      if (scrollT + clientH >= scrollH - distance) {
        if (!this.nativeScroll.lockLoad) {
          this.nativeScroll.lockLoad = true
          setTimeout(() => {
            eventBus.$emit('InviteScroll', { type: 'arriveBottom' })
          }, 100)
        }
      }

      eventBus.$emit('InviteScroll', { type: 'scroll' })
    },
    newNativeScroll() {
      document.body.addEventListener('scroll', this.initNativeScroll)
      this.nativeScroll = {
        lockLoad: false,
        finishPullUp: function () {
          this.lockLoad = false
        },
        refresh: function () {
          // this.lockLoad = false
        },
      }
    },
  },
  created() {
    agentPageTypeApi().then(() => {
      this.getBaseInfo()
      const initTabIndex = this.$route.query.tab
      if (initTabIndex) {
        this.handleSwitchTab(initTabIndex)
      }

      eventBus.$on('refreshInvitePage', () => {
        this.getBaseInfo({ silent: true })
        this.handleSwitchTab(this.tabIndex)
      })
    })
  },
  mounted() {
    this.newNativeScroll()
  },
  beforeDestroy() {
    this.stopBindUpAgentCountdown()
  },
}
</script>

<style lang="scss">
.invite-root {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 20px;
  position: relative;
  background: #e9e4db;

  .custom-nav-block {
    position: fixed;
    top: 0;
    z-index: 10000;
    width: 100%;

    &.nav-default {
      background: transparent;
    }

    &.nav-scrolling {
      background: #eee5d5;
    }

    .van-nav-bar {
      background: transparent;

      .van-nav-bar__title {
        font-family: 'InterTight-Medium', var(--string-font);
        font-size: var(--fs-20);
        line-height: var(--lh-title-24);
        color: #333333;
        font-weight: var(--fw-500);
      }

      .van-nav-bar__content {
        .van-nav-bar__left {
          .nav-back {
            display: flex;
            align-items: center;
            padding: 10px;

            .left-nav {
              width: 20px;
              height: 20px;
            }
          }
        }

        .van-nav-bar__right {
          padding: 0 10px;

          > .target-avatar {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            border: 1px solid #ffffff;
            box-sizing: border-box;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .invite-hero {
    position: relative;
    width: 100%;

    .hero-bg {
      width: 100%;
      min-height: 375px;
      padding: 12px 16px 16px;
      background: url('~@/assets/packageAssets/views/P2_Page/Invite/default/top-bg.webp') top center / 100% auto no-repeat;
    }

    .earn-tips {
      margin-top: 12px;
      color: #333333;
      font-style: italic;

      &.is-placeholder {
        .earn-percent,
        .earn-bonus {
          display: inline-block;
          min-width: 48px;
          color: #c9bfb0;
        }
      }

      .earn-line {
        margin: 0;
        font-family: 'PlusJakartaSans-Regular';
        font-weight: var(--fw-800);
        font-size: var(--fs-28);
        line-height: var(--lh-headline-36);
        font-style: italic;

        .earn-percent,
        .earn-bonus {
          font-size: 36px;
          line-height: 40px;
          font-weight: var(--fw-700);
          font-style: italic;
        }
      }
    }

    .invite-code {
      display: inline-flex;
      align-items: center;
      margin-top: 16px;
      padding: 4px 12px;
      background: #f3e9d6;
      backdrop-filter: blur(6px);
      border-radius: 36px;

      > * + * {
        margin-left: 4px;
      }

      &.is-placeholder {
        pointer-events: none;

        .code-value {
          color: #c9bfb0;
          letter-spacing: 2px;
        }
      }

      .code-label {
        font-family: var(--string-font);
        font-size: var(--fs-12);
        line-height: var(--lh-body-18);
        color: #333333;
      }

      .code-value {
        font-family: var(--string-font);
        font-size: var(--fs-14);
        line-height: var(--lh-body-20);
        color: #925e0d;
      }

      .copy-icon {
        width: 16px;
        height: 16px;
      }
    }

    .action-btns {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-top: 16px;
      max-width: calc(100% - 90px);

      &.is-disabled {
        opacity: 0.7;
        pointer-events: none;
      }
    }

    .btn-invite-hostess,
    .btn-invite-sub {
      min-width: 163px;
      min-height: 44px;
      padding: 12px 12px;
      margin-bottom: 8px;
      border-radius: 44px;

      display: flex;
      align-items: center;
      justify-content: center;

      font-family: var(--string-font);
      font-size: var(--fs-14);
      line-height: var(--lh-title-20);
      color: #ffffff;
    }

    .btn-invite-hostess {
      border: 1px solid #fef9db;
      background: linear-gradient(180deg, #f6e0b3 0%, #c6a175 33.17%, #74461a 100%);
    }

    .btn-invite-sub {
      border: 1px solid #fef4dd;
      background: linear-gradient(180deg, #f7dac0 0%, #d18762 32.69%, #9c2f22 100%);
      box-shadow: inset 0 -3px 6px 0 #eda265;
    }

    .side-actions {
      position: absolute;
      top: 244px;
      right: 0;
      display: flex;
      flex-direction: column;
      z-index: 2;

      > * + * {
        margin-top: 12px;
      }
    }

    .side-btn {
      display: flex;
      align-items: center;
      padding: 10px 8px;
      border-top: 1px solid #ffffff;
      border-left: 1px solid #ffffff;
      border-radius: 8px 0 0 8px;
      background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0.8) 100%);

      > * + * {
        margin-left: 2px;
      }

      img {
        width: 16px;
        height: 16px;
      }

      span {
        font-family: var(--string-font);
        font-size: var(--fs-12);
        line-height: var(--lh-title-20);
        letter-spacing: -0.3px;
        color: #925e0d;
        white-space: nowrap;
      }
    }

    .bind-up-agent {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 16px 24px;
      padding: 16px;
      border-top: 1px solid #ffffff;
      border-radius: 10px;
      background: linear-gradient(180deg, #f3ebdd 0%, #ffffff 100%);

      .bind-up-agent-title {
        flex: 1;
        font-family: var(--string-font);
        font-size: var(--fs-14);
        line-height: var(--lh-title-20);
        color: #333333;
      }

      .bind-up-agent-right {
        display: flex;
        align-items: center;

        > * + * {
          margin-left: 2px;
        }
      }

      .bind-up-agent-time {
        font-family: var(--string-font);
        font-size: var(--fs-14);
        line-height: var(--lh-label-18);
        color: #333333;

        &.is-urgent {
          font-weight: var(--fw-600);
          font-variant-numeric: tabular-nums;
          color: #333333;
        }
      }

      .bind-up-agent-arrow {
        width: 16px;
        height: 16px;
      }
    }
  }

  .tab-pane-wrap {
    width: 100%;
  }

  .switch-tab {
    width: 343px;
    margin: 0 auto;
    background: #e9e4db;
    position: sticky;
    z-index: 99;

    .switch-tab-bg {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      min-height: 44px;
      background: #d0c6b6;
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
    }

    .switch-tab-inner {
      display: flex;
      align-items: flex-end;
      width: 100%;
      min-height: 44px;
      border-radius: 16px 16px 0 0;
      overflow: visible;
    }

    .tab {
      position: relative;
      z-index: 0;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 44px;
      padding: 0 4px;
      font-family: var(--string-font);
      font-size: var(--fs-14);
      line-height: var(--lh-title-20);
      color: #695c46;
      text-align: center;
      box-sizing: border-box;

      &:not(.active-tab) + .tab:not(.active-tab)::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        z-index: 1;
        width: 1px;
        height: 18px;
        margin-top: -9px;
        background: #b4a081;
        border-radius: 1px;
      }

      .tab-inner {
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }

      &.active-tab {
        z-index: 2;
        overflow: visible;
        min-height: 52px;
        padding: 12px 4px 12px;
        color: #925e0d;
        background: linear-gradient(180deg, #f5e1c0 0%, #fefefe 70%);
        border-top: 1px solid #ffffff;
        border-radius: 16px 16px 0 0;

        &:not(:first-child)::before {
          content: '';
          position: absolute;
          left: -16px;
          bottom: 0;
          width: 16px;
          height: 26px;
          background-color: #fefefe;
          -webkit-mask-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/tab-icon-left.webp');
          -webkit-mask-repeat: no-repeat;
          -webkit-mask-position: center;
          -webkit-mask-size: contain;
          mask-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/tab-icon-left.webp');
          mask-repeat: no-repeat;
          mask-position: center;
          mask-size: contain;
          z-index: 3;
          pointer-events: none;
        }

        &:not(:last-child)::after {
          content: '';
          position: absolute;
          right: -16px;
          bottom: 0;
          width: 16px;
          height: 26px;
          background-color: #fefefe;
          -webkit-mask-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/tab-icon-right.webp');
          -webkit-mask-repeat: no-repeat;
          -webkit-mask-position: center;
          -webkit-mask-size: contain;
          mask-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/tab-icon-right.webp');
          mask-repeat: no-repeat;
          mask-position: center;
          mask-size: contain;
          z-index: 3;
          pointer-events: none;
        }
      }
    }
  }

  .sub-agent-bean {
    width: 28px;
    height: 28px;
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .invite-root {
    .invite-hero {
      .hero-bg {
        background: url('~@/assets/packageAssets/views/P2_Page/Invite/default/top-bg-ar.webp') top center / 100% auto no-repeat;
      }

      .earn-tips {
        text-align: end;
      }

      .invite-code {
        > * + * {
          margin-left: 0;
          margin-right: 4px;
        }
      }

      .side-actions {
        right: unset;
        left: 0;

        .side-btn {
          border-left: none;
          border-right: 1px solid #ffffff;
          border-radius: 0 8px 8px 0;

          > * + * {
            margin-left: 0;
            margin-right: 2px;
          }
        }
      }

      .bind-up-agent .bind-up-agent-right > * + * {
        margin-left: 0;
        margin-right: 2px;
      }
    }

    .switch-tab {
      .switch-tab-inner {
        direction: rtl;
      }

      .tab {
        &:not(.active-tab) + .tab:not(.active-tab)::before {
          left: auto;
          right: 0;
        }

        &.active-tab {
          &:first-child {
            &::after {
              display: none;
            }

            &::before {
              content: '';
              position: absolute;
              left: -16px;
              right: auto;
              bottom: 0;
              width: 16px;
              height: 26px;
              background-color: #fefefe;
              -webkit-mask-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/tab-icon-left.webp');
              -webkit-mask-repeat: no-repeat;
              -webkit-mask-position: center;
              -webkit-mask-size: contain;
              mask-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/tab-icon-left.webp');
              mask-repeat: no-repeat;
              mask-position: center;
              mask-size: contain;
              z-index: 3;
              pointer-events: none;
            }
          }

          &:last-child {
            &::before {
              display: none;
            }

            &::after {
              content: '';
              position: absolute;
              right: -16px;
              left: auto;
              bottom: 0;
              width: 16px;
              height: 26px;
              background-color: #fefefe;
              -webkit-mask-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/tab-icon-right.webp');
              -webkit-mask-repeat: no-repeat;
              -webkit-mask-position: center;
              -webkit-mask-size: contain;
              mask-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/tab-icon-right.webp');
              mask-repeat: no-repeat;
              mask-position: center;
              mask-size: contain;
              z-index: 3;
              pointer-events: none;
            }
          }

          &:not(:first-child):not(:last-child) {
            &::before {
              left: auto;
              right: -16px;
              -webkit-mask-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/tab-icon-right.webp');
              mask-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/tab-icon-right.webp');
            }

            &::after {
              right: auto;
              left: -16px;
              -webkit-mask-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/tab-icon-left.webp');
              mask-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/tab-icon-left.webp');
            }
          }
        }
      }
    }
  }
}
</style>
